import React from 'react';
import styled from 'styled-components/macro';
import { trackFontHeavy } from '../../styles/Font';
import { columnFormat, rowFormat, columns } from './List.js';

const ListHeaderContainer = styled.div`
  ${rowFormat}
  height: 30px;
`;

const ListHeaderItem = styled.div`
  ${columnFormat}
  ${trackFontHeavy}
  flex: ${({ flexSize }) => flexSize};
`;

const ListHeader = () => (
  <ListHeaderContainer>
    {columns.map(({ flexSize, name }, index) => (
      <ListHeaderItem
        flexSize={flexSize}
        isTitle={index === 0 ? 1 : 2}
        key={`listheaderitem-${flexSize}-${name}`}
      >
        {name}
      </ListHeaderItem>
    ))}
  </ListHeaderContainer>
);

export default ListHeader;
